import { SiMoonrepo } from "react-icons/si";

export function Mission({ mission }) {
  return(
    <>
      <section className="hero is-medium is-primary component-container">
        <div className="hero-body mb-0 pb-0">
          <div className="columns is-desktop">
            
            <div className="column">
              <p className="has-text-centered">
                <SiMoonrepo style={{fontSize:"150px"}} />
              </p>
              <h3 className='subtitle is-3 bf-sub-title has-text-centered'>{mission.title}</h3>
              <p className='card-content is-size-5'>{mission.text}</p>
              
            </div>

          </div>
        </div>
      </section>
    </>
  );
}